import {
  FeedbackResponseDTO,
  LiveClassFeedbackService,
} from '@openeducation/oe-it-services';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../../environment/environment.provider';

export interface UseLiveClassFeedbackProps {
  contactId?: string;
}
export const useLiveClassFeedbacks = ({
  contactId,
}: UseLiveClassFeedbackProps) => {
  const { environment } = useEnvironmentContext();

  const {
    data: liveClassFeedbacks,
    isLoading: isLoadingLiveClassFeedbacks,
    isError: isErrorLiveClassFeedbacks,
  } = useQuery<FeedbackResponseDTO[]>(
    ['liveClassFeedbacks', contactId],
    () =>
      LiveClassFeedbackService.getLiveClassFeedbacks(environment, contactId),
    {
      enabled: !!contactId,
    }
  );

  return {
    liveClassFeedbacks,
    isLoadingLiveClassFeedbacks,
    isErrorLiveClassFeedbacks,
    isFirstClass:
      !isLoadingLiveClassFeedbacks &&
      (!liveClassFeedbacks || liveClassFeedbacks.length === 0),
  };
};
